<template>
  <text-image
    :text="text"
    :image="image"
    :image-left="imageLeft"
    :full-width="true"
  />
</template>

<script>
import TextImage from "./TextImage";

export default {
  props: {
    text: Array,
    image: Object,
    imageLeft: Boolean,
  },
  components: {
    TextImage,
  },
};
</script>
